import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from 'react-router-dom';

const dsn = process.env.REACT_APP_SENTRY_DSN;
const sentryEnabled = process.env.REACT_APP_SENTRY_ENABLED === 'true';

if (dsn && sentryEnabled) {
  Sentry.init({
    dsn,
    environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || 'production',
    release: process.env.REACT_APP_SENTRY_RELEASE,
    sampleRate: parseFloat(process.env.REACT_APP_SENTRY_SAMPLE_RATE || '1.0'),
    tracesSampleRate: parseFloat(process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE || '0'),
    // Sentry Logs
    enableLogs: true,
    integrations: [
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      Sentry.replayIntegration({
        blockAllMedia: false,
        maskAllText: false,
      }),
      // Sends console.error/warn to Sentry Issues (error grouping + breadcrumbs)
      Sentry.captureConsoleIntegration({
        levels: ['error', 'warn'],
      }),
      // Sends console output to Sentry Logs product (structured, searchable log view).
      // Complementary to captureConsoleIntegration — console.errors go to both Issues AND Logs.
      Sentry.consoleLoggingIntegration({
        levels: ['error', 'warn'],
      }),
    ],
    replaysSessionSampleRate: parseFloat(process.env.REACT_APP_SENTRY_REPLAYS_SESSION_SAMPLE_RATE || '0'),
    replaysOnErrorSampleRate: parseFloat(process.env.REACT_APP_SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE || '1.0'),
  });
}
